import API from "../../../services/api";

const BASE = "/tds/compliance";
const q = (fy, quarter) => ({ params: { fy, quarter } });

/* ── overview / summary ── */
export const getOverview = (fy, quarter) => API.get(`${BASE}/overview`, q(fy, quarter)).then((r) => r.data);
export const refreshSummary = (fy, quarter) => API.post(`${BASE}/summary/refresh`, null, q(fy, quarter)).then((r) => r.data);

/* ── deposit ── */
export const markDeposit = (fy, quarter, body) => API.post(`${BASE}/deposit`, body, q(fy, quarter)).then((r) => r.data);

/* ── challans ── */
export const listChallans = (fy, quarter) => API.get(`${BASE}/challans`, q(fy, quarter)).then((r) => r.data);
export const createChallan = (fy, quarter, body) => API.post(`${BASE}/challans`, body, q(fy, quarter)).then((r) => r.data);
export const updateChallan = (challanId, body) => API.put(`${BASE}/challans/${challanId}`, body).then((r) => r.data);
export const deleteChallan = (challanId) => API.delete(`${BASE}/challans/${challanId}`).then((r) => r.data);

/* ── return / 24Q ── */
export const validateReturn = (fy, quarter) => API.get(`${BASE}/validate`, q(fy, quarter)).then((r) => r.data);
export const generateReturn = (fy, quarter) => API.post(`${BASE}/return/generate`, null, q(fy, quarter)).then((r) => r.data);
export const getReturn = (fy, quarter) => API.get(`${BASE}/return`, q(fy, quarter)).then((r) => r.data);

/* ── upload / acknowledgement ── */
export const setUploadStatus = (fy, quarter, body) => API.post(`${BASE}/upload-status`, body, q(fy, quarter)).then((r) => r.data);
export const getAck = (fy, quarter) => API.get(`${BASE}/acknowledgement`, q(fy, quarter)).then((r) => r.data);
export const saveAck = (fy, quarter, body) => API.post(`${BASE}/acknowledgement`, body, q(fy, quarter)).then((r) => r.data);

/* ── form 16 ── */
export const getForm16Status = (fy) => API.get(`${BASE}/form16`, { params: { fy } }).then((r) => r.data);
export const recordForm16 = (fy, body) => API.post(`${BASE}/form16/record`, body, { params: { fy } }).then((r) => r.data);
export const markForm16Emailed = (fy) => API.post(`${BASE}/form16/mark-emailed`, null, { params: { fy } }).then((r) => r.data);

/* ── monthly ledger (payroll-fed) ── */
export const syncLedger = (fy, quarter) => API.post(`${BASE}/ledger/sync`, null, q(fy, quarter)).then((r) => r.data);
export const getLedger = (fy, quarter) => API.get(`${BASE}/ledger`, q(fy, quarter)).then((r) => r.data);
export const getTrend = (fy) => API.get(`${BASE}/ledger/trend`, { params: { fy } }).then((r) => r.data);

/* ── audit ── */
export const listAudit = () => API.get(`${BASE}/audit`).then((r) => r.data);

/* ── notifications (Phase 4) ── */
export const listNotifications = (unreadOnly = false) => API.get(`${BASE}/notifications`, { params: { unread_only: unreadOnly } }).then((r) => r.data);
export const evaluateNotifications = (fy) => API.post(`${BASE}/notifications/evaluate`, null, { params: { fy } }).then((r) => r.data);
export const markNotificationRead = (id) => API.patch(`${BASE}/notifications/${id}/read`).then((r) => r.data);

/* ── filing provider adapter (Phase 4) ── */
export const getProvider = () => API.get(`${BASE}/provider`).then((r) => r.data);
export const fileReturn = (fy, quarter, provider) => API.post(`${BASE}/return/file`, null, { params: { fy, quarter, provider } }).then((r) => r.data);

/* ── reports (CSV blob) ── */
export async function downloadReport(kind, fy, quarter) {
  const res = await API.get(`${BASE}/reports/${kind}`, { params: { fy, quarter }, responseType: "blob" });
  const cd = res.headers?.["content-disposition"] || "";
  const m = /filename="?([^"]+)"?/i.exec(cd);
  const name = m?.[1] || `${kind}.csv`;
  const url = URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  URL.revokeObjectURL(url);
  return name;
}

export function tdsErr(e) {
  return e?.response?.data?.detail || e?.message || "Request failed";
}
